import { CATALOG_STATS } from "../../actions/types";

const initialState = {
	productStats: {
		catalogType: 1,
		itemsCount: 0,
		activeLowInventoryIds: [],
		inactiveLowInventoryIds: [],
		activeOutOfStockItems: 0,
		inactiveOutOfStockItems: 0,
		totalActive: 0,
		totalActiveDeleted: 0,
		totalActiveInactive: 0
	},
	serviceStats: {
		catalogType: 2,
		itemsCount: 0,
		activeLowInventoryIds: [],
		inactiveLowInventoryIds: [],
		activeOutOfStockItems: 0,
		totalActive: 0,
		totalActiveDeleted: 0,
		totalActiveInactive: 0
	},
	assetStats: {
		catalogType: 3,
		itemsCount: 0,
		activeOutOfStockItems: 0,
		totalActive: 0,
		totalActiveDeleted: 0,
		totalActiveInactive: 0
	}
};

export default function catalogRootReducer(state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case CATALOG_STATS: {
			const catalogEntityArr = payload || [];
			const productStats = catalogEntityArr.filter(
				entity => entity.catalogType === 1
			);
			const serviceStats = catalogEntityArr.filter(
				entity => entity.catalogType === 2
			);
			return {
				...state,
				productStats: productStats[0] || state.productStats,
				serviceStats: serviceStats[0] || state.serviceStats
			};
		}
		default:
			return state;
	}
}
